import client from './client';

export interface MeResponse {
	id: number;
	email: string;
	name: string;
	picture_url?: string | null;
	created_at?: string;
	last_login_at?: string;
}

export interface GoogleLoginResponse {
	token: string;
	user: {
		id: number;
		email: string;
		name: string;
		picture_url?: string | null;
	};
}

const authApi = {
	getMe: () => client.get<MeResponse>('/admin/me'),

	googleLogin: (credential: string) =>
		client.post<GoogleLoginResponse>('/admin/googleLogin', {
			credential,
		}),
};

export default authApi;
